/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    var str = data.description;
  } else {
   	var str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
    jQuery('.ltn__utilize-cart-menu').removeClass("ltn__utilize-open");
    jQuery('.ltn__utilize-cart-menu').removeClass("dontshow");
    jQuery('.ltn__utilize-overlay').fadeOut();
  },1000);
  jQuery('.ltn__utilize-cart-menu').addClass("dontshow");
}

Shopify.addItem = function(variant_id, quantity, callback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id,callback) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      beforeSend: function(){
        if(form_id == "add-item-qv") {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
        }
      },
      data: jQuery('#' + form_id).serialize(),
      dataType: 'json',
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item);
        }
        else {
          if(form_id != "add-item-qv") {
            Shopify.cartPopapForm(variant_id);
          } else {
          	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
            jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
            setTimeout(function(){
              	jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            	jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
            }, 2000);
          }
          Shopify.onItemAdded(line_item);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        if(form_id != "add-item-qv") {
          Shopify.onError(XMLHttpRequest, textStatus);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
          setTimeout(function(){
            jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    };
    jQuery.ajax(params);
};

/* user functions */

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
}

Shopify.cartPopap = function(variant_id) {
  	var image = jQuery('.'+variant_id+':first .popup_cart_image').attr("src");
  	var title = jQuery('.'+variant_id+':first .popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
  	jQuery('.productmsg').text(''+title+'');  
  	jQuery('#modalAddToCart').modal("toggle");
}
Shopify.cartPopapForm = function(variant_id) {
  	var image = jQuery('.product_variant_image').attr("src");
  	var title = jQuery('#popup_cart_title').text();
  	jQuery('.popupimage').attr("src",''+image+'');
	jQuery('.productmsg').text(''+title+'');
	jQuery('#modalAddToCart').modal("toggle");
}

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  var formatMoney = window.money_format;
  if ((typeof cart_cell_id) === 'string') {
    var cart_cell = jQuery(cart_cell_id);
    if (cart_cell.length) {

      cart_cell.empty();
      var caAlloc = caAllocate(cart);

  
      jQuery.each(cart, function(key, value) {
        if (key === 'items') {
          
          if (value.length == 1) {
            jQuery(".cart-item-display").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<div class="mini-cart-item clearfix"><div class="mini-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt=""></a><span onclick="Shopify.removeItem(' + item.variant_id + ')" class="mini-cart-item-delete"><i class="icon-cancel"></i></span></div><div class="mini-cart-info"><h6><a href="' + item.url + '">' + item.title + '</a></h6><span class="mini-cart-quantity">' + item.quantity + ' x ' + Shopify.formatMoney(item.original_price, formatMoney) + '</span>' + caLineSave(item, formatMoney, caAlloc[i]) + '</div></div>').appendTo(table);
            });
          }			
          else if (value.length) {
            jQuery(".cart-item-display").css({"display": "block"});
            jQuery(".cart-empty-title").css({"display": "none"});
            
            var table = jQuery(cart_cell_id);
            jQuery.each(value, function(i, item) {
              if(i > 19){
                  return false;
              }
              jQuery('<div class="mini-cart-item clearfix"><div class="mini-cart-img"><a href="' + item.url + '"><img src="' + item.image + '" alt=""></a><span onclick="Shopify.removeItem(' + item.variant_id + ')" class="mini-cart-item-delete"><i class="icon-cancel"></i></span></div><div class="mini-cart-info"><h6><a href="' + item.url + '">' + item.title + '</a></h6><span class="mini-cart-quantity">' + item.quantity + ' x ' + Shopify.formatMoney(item.original_price, formatMoney) + '</span>' + caLineSave(item, formatMoney, caAlloc[i]) + '</div></div>').appendTo(table);
            });
          }
          else {
            jQuery(".cart-item-display").css({"display": "none"});
            jQuery(".cart-empty-title").css({"display": "block"});
          }
        }
      });

      
    }
  }

  changeHtmlValue(".shopping-cart__total", Shopify.formatMoney(cart.total_price, formatMoney));
  caMiniCartSavings(cart, formatMoney);
  changeHtmlValue(".bigcounter", cart.item_count);

  jQuery('.currency .active').trigger('click');
}

//Utils
function changeHtmlValue (cell, value) {
  var $cartLinkText = jQuery(cell);
  $cartLinkText.html(value);
};
/* Chief Angler: buy-more-save-more savings in the mini cart (native automatic discounts) */
function caAllocate(cart) {
  /* per-line share of buy-more-save-more discount: real allocations first, else proportional to line subtotal */
  var items = cart.items || [], out = [], orig = 0, run = 0;
  items.forEach(function (it) { orig += it.original_line_price || 0; });
  var save = Math.max(0, orig - (cart.total_price || 0));
  items.forEach(function (it, idx) {
    var s = 0;
    (it.line_level_discount_allocations || []).forEach(function (a) { s += a.amount || 0; });
    if (s === 0 && save > 0 && orig > 0) {
      s = (idx === items.length - 1) ? save - run : Math.floor(save * (it.original_line_price || 0) / orig);
    }
    s = Math.max(0, Math.min(s, it.original_line_price || 0));
    run += s; out.push(s);
  });
  return out;
}
function caLineSave(item, fmt, s) {
  var o = item.original_line_price;
  if (typeof s !== 'number') { var f = (typeof item.final_line_price === 'number') ? item.final_line_price : item.line_price; s = o - f; }
  if (!(s > 0)) return '';
  return '<span class="ca-mc-line"><s>' + Shopify.formatMoney(o, fmt) + '</s> <b>' + Shopify.formatMoney(o - s, fmt) + '</b> · You save ' + Shopify.formatMoney(s, fmt) + '</span>';
}
function caMiniCartSavings(cart, fmt) {
  try {
    var box = jQuery('[data-ca-mc-save]'), nudge = jQuery('[data-ca-mc-nudge]');
    var orig = 0; (cart.items || []).forEach(function (it) { orig += it.original_line_price || 0; });
    var save = orig - (cart.total_price || 0);
    if (save > 0) {
      var titles = [];
      (cart.cart_level_discount_applications || []).forEach(function (a) { if (a.title && titles.indexOf(a.title) < 0) titles.push(a.title); });
      (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title; if (t && titles.indexOf(t) < 0) titles.push(t); }); });
      box.find('[data-ca-mc-title]').text(titles.join(', '));
      box.find('[data-ca-mc-amt]').text(Shopify.formatMoney(save, fmt));
      box.css('display', 'flex');
    } else { box.css('display', 'none'); }
    var q = cart.item_count || 0, tiers = [[2, 5], [3, 10], [5, 15]], next = null;
    for (var i = 0; i < tiers.length; i++) { if (q < tiers[i][0]) { next = tiers[i]; break; } }
    if (next && q > 0) {
      var more = next[0] - q;
      nudge.html('Add ' + more + ' more lure' + (more > 1 ? 's' : '') + ' to get <b>' + next[1] + '% off</b> your whole order').css('display', 'block');
    } else { nudge.css('display', 'none'); }
  } catch (e) {}
}
